import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "ab0e48e2-2110-4f2b-87a9-a47ff7c0b16f",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    shuffle: true,
    type: "number",
    prefixText: "The <b>frequency</b> is",
    unit: "Hz",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 100,
};
